import { useHistory } from "react-router-dom";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Container from "./components/Container";
import Terrazzo from "./components/Terrazzo";
import CategoryTile from "./components/CategoryTile";
import Grid from "./components/Grid";
import PincodeSearch from "./components/PincodeSearch";
import { CATEGORIES, ICONS } from "./categories";
import styles from "./Home.module.css";

const TRUST = [
  { title: "Verified pros", body: "Every provider is checked before they list." },
  { title: "Sanitised & single-use", body: "Hygienic kits on every visit." },
  { title: "Low-contact service", body: "Safe, respectful, on your terms." },
];

const STEPS = [
  { title: "Pick a service", body: "Choose from cleaning, cooking, plumbing, electrical, or househelp." },
  { title: "Choose a pro near you", body: "Search by pincode and compare ratings." },
  { title: "Book & rate", body: "Get it done, then leave a review to help others." },
];

export default function Home() {
  const history = useHistory();

  const goToService = (service_category, pincode = "") => {
    localStorage.setItem("name", service_category);
    localStorage.setItem("pincode", pincode);
    history.push("/showservices");
  };

  return (
    <div>
      <Nav />

      <section className={styles.hero}>
        <Terrazzo className={styles.heroBg} />
        <Container>
          <div className={styles.heroInner}>
            <h1 className={styles.title}>The care your home deserves.</h1>
            <p className={styles.sub}>Trusted pros, at your doorstep.</p>
            <div className={styles.search}>
              <PincodeSearch
                categories={CATEGORIES}
                onSearch={({ service_category, pincode }) => goToService(service_category, pincode)}
              />
            </div>
          </div>
        </Container>
      </section>

      <section className={styles.trust}>
        <Container>
          <div className={styles.trustRow}>
            {TRUST.map((t) => (
              <div key={t.title} className={styles.trustItem}>
                <h3 className={styles.trustTitle}>{t.title}</h3>
                <p className={styles.muted}>{t.body}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section id="services" className={styles.section}>
        <Container>
          <h2 className={styles.h2}>Services your home deserves</h2>
          <p className={styles.muted}>Expert service providers at your doorstep.</p>
          <div className={styles.tiles}>
            <Grid min="180px" gap="4">
              {CATEGORIES.map((c) => (
                <CategoryTile
                  key={c.value}
                  label={c.label}
                  icon={ICONS[c.value]}
                  onClick={() => goToService(c.value)}
                />
              ))}
            </Grid>
          </div>
        </Container>
      </section>

      <section className={styles.section}>
        <Container>
          <h2 className={styles.h2}>How it works</h2>
          <ol className={styles.steps}>
            {STEPS.map((s, i) => (
              <li key={s.title} className={styles.step}>
                <span className={styles.stepNum}>{i + 1}</span>
                <div>
                  <h3 className={styles.stepTitle}>{s.title}</h3>
                  <p className={styles.muted}>{s.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </Container>
      </section>

      <Footer />
    </div>
  );
}
